import { OnInit, QueryList, ElementRef } from '@angular/core';
import { Validators } from "@angular/forms";
import { ERROR_CODE } from "../../config/error_code";
import { TIMERS_CONFIG } from "../../config/project";
import { AUTH_CODES } from "../../config/auth_codes";
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "../../service/app-version/appVersion.service";
import * as i3 from "../../modules/auth/_services/authentication.service";
import * as i4 from "../../service/loader.service";
import * as i5 from "../../service/phoneMask.service";
import * as i6 from "@angular/router";
import * as i7 from "../../service/main-tabs.service";
import * as i8 from "../../service/app/appPrompt.service";
import * as i9 from "../../shared/popup/popup.component";
var AUTH_TYPE = {
    sms: 'smsPin',
    smsPinPassword: 'smsPinPassword',
    authPin: 'authPin',
    authPinPassword: 'authPinPassword',
    password: 'clintPassword'
};
var LoginComponent = /** @class */ (function () {
    function LoginComponent(formBuilder, appVersionService, authenticationService, loaderService, phoneMaskService, router, mainTabsService, activatedRoute, auth, appPromptService, popupComponent) {
        this.formBuilder = formBuilder;
        this.appVersionService = appVersionService;
        this.authenticationService = authenticationService;
        this.loaderService = loaderService;
        this.phoneMaskService = phoneMaskService;
        this.router = router;
        this.mainTabsService = mainTabsService;
        this.activatedRoute = activatedRoute;
        this.auth = auth;
        this.appPromptService = appPromptService;
        this.popupComponent = popupComponent;
        this.phoneFormActive = true;
        this.authCode = null;
        this.registrationPartActive = false;
        this.registrationPartStep = 1;
        this.isRegistrationUpdate = false;
        this.isHelpStep = 0;
        this.phoneLastFour = ' ';
        this.numOfDigits = 4;
        this.authType = '';
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.phoneFormInit();
        this.pinFormInit();
        this.registrationFormInit();
        this.phoneMask = this.phoneMaskService.setPhoneMask();
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params.promo) {
                _this.promoCode = params.promo;
                _this.registrationForm.controls.promo.setValue(params.promo);
            }
        });
    };
    LoginComponent.prototype.phoneFormInit = function () {
        this.phoneForm = this.formBuilder.group({
            phone: [null, Validators.required]
        });
        this.focusPhoneInput();
    };
    LoginComponent.prototype.pinFormInit = function () {
        this.pinForm = this.formBuilder.group({
            digits: this.formBuilder.array([]),
            password: [null, Validators.required],
        });
        for (var i = 0; i < this.numOfDigits; i++) {
            this.pinForm.get('digits').push(this.formBuilder.control(null, Validators.required));
        }
    };
    LoginComponent.prototype.registrationFormInit = function () {
        this.registrationForm = this.formBuilder.group({
            password: [null, Validators.required],
            reEnteredPassword: [null, Validators.required],
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            promo: [null, Validators.required]
        });
    };
    LoginComponent.prototype.onPhoneSubmit = function () {
        var _this = this;
        if (this.phoneForm.controls.phone.invalid) {
            return;
        }
        var phone = this.phoneForm.controls.phone.value;
        var authHash = localStorage.getItem('authHash');
        this.authenticationService.checkPhoneAndSendPin(phone, authHash).subscribe(function (data) {
            // if (environment.frontEndTest) {
            //     data.status = false;
            //     data.code = AUTH_CODES.showPassword;
            //     data.firstName = "";
            //     data.email = "dkdk@kddk";
            // }
            try {
                if (!data.status) {
                    if (data.code) {
                        if (data.code == AUTH_CODES.registerNewUser) {
                            _this.errorHandlerRegisterNewUser();
                        }
                        else if (data.code == AUTH_CODES.showSMSPin) {
                            _this.showAuthSecondStep(data.code);
                            _this.showSMSLoginStep();
                        }
                        else if (data.code == AUTH_CODES.showAuthPin) {
                            _this.showAuthSecondStep(data.code);
                            _this.showAuthLoginStep();
                        }
                        else if (data.code == AUTH_CODES.showPassword) {
                            _this.showAuthSecondStep(data.code);
                            _this.showPasswordLoginStep();
                        }
                        else if (data.code == AUTH_CODES.updateUserInfo) {
                            _this.errorHandlerUpdateUserInfo(data);
                        }
                        else {
                            _this.popupComponent.showPopupError({ text: data.message });
                        }
                    }
                    else {
                        _this.popupComponent.showPopupError({ text: data.message });
                    }
                }
            }
            catch (e) {
                _this.loaderService.hideAndShowTryAgain();
            }
        }, function (error) {
            _this.loaderService.hideAndShowTryAgain();
        }, function () {
            setTimeout(function () {
                _this.loaderService.hide();
            }, 0);
        });
    };
    LoginComponent.prototype.showAuthSecondStep = function (code) {
        this.authCode = code;
        this.phoneFormActive = false;
    };
    LoginComponent.prototype.showSMSLoginStep = function () {
        var phone = this.phoneForm.controls.phone.value;
        this.phoneLastFour = phone.substr(-4);
        this.authType = AUTH_TYPE.sms;
        this.focusPinInputs();
    };
    LoginComponent.prototype.showAuthLoginStep = function () {
        this.authType = AUTH_TYPE.authPin;
        this.focusPinInputs();
    };
    LoginComponent.prototype.showPasswordLoginStep = function () {
        this.authType = AUTH_TYPE.password;
        this.focusPasswordInput();
    };
    LoginComponent.prototype.errorHandlerRegisterNewUser = function () {
        this.registrationPartActive = true;
        this.phoneFormActive = false;
        this.authenticationService.accountLoginBtnText();
        this.isRegistrationUpdate = false;
        this.userRegistrationUpdateData = null;
        this.focusPasswordInput();
    };
    LoginComponent.prototype.errorHandlerUpdateUserInfo = function (data) {
        this.registrationPartActive = true;
        this.phoneFormActive = false;
        this.authenticationService.accountLoginBtnText();
        this.isRegistrationUpdate = true;
        this.userRegistrationUpdateData = data;
        this.focusPasswordInput();
    };
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        var phone = this.phoneForm.controls.phone.value;
        var password = this.isSecondStepPassword() || this.isSecondStepAuthAuthPinPassword() || this.isSecondStepAuthSMSPinPassword() ? this.pinForm.controls.password.value : null;
        var code = this.authCode;
        var authHash = localStorage.getItem('authHash');
        var pin = this.pinForm.controls.digits.value;
        pin = this.isSecondStepAuthSMSPin() || this.isSecondStepAuthAuthPin() || this.isHelpStep ? pin.join('') : null;
        if (this.isHelpStep) {
            if (this.isHelpStep === 2) {
                this.authenticationService.loginSendResetCode(phone, pin).subscribe(function (data) {
                    try {
                        if (data.status) {
                            _this.isHelpStep = 3;
                            _this.focusRegistrationPasswordInput();
                        }
                        else {
                            _this.popupComponent.showPopupError({ text: data.message });
                        }
                    }
                    catch (e) {
                        _this.loaderService.hideAndShowTryAgain();
                    }
                }, function (error) {
                    _this.loaderService.hideAndShowTryAgain();
                }, function () {
                    _this.loaderService.hide();
                });
            }
            else if (this.isHelpStep === 3) {
                var password_1 = this.registrationForm.controls.password.value;
                this.authenticationService.loginAfterReset(phone, pin, password_1).subscribe(function (data) {
                    _this.checkLoginSubmit(data);
                }, function (error) {
                    _this.loaderService.hideAndShowTryAgain();
                }, function () {
                    _this.loaderService.hide();
                });
            }
        }
        else if (this.registrationPartActive) {
            this.onRegisterNewUser();
        }
        else {
            this.authenticationService.login(phone, pin, password, code, authHash).subscribe(function (data) {
                _this.checkLoginSubmit(data);
            }, function (error) {
                _this.loaderService.hideAndShowTryAgain();
            }, function () {
                _this.loaderService.hide();
            });
        }
    };
    LoginComponent.prototype.checkLoginSubmit = function (data) {
        var _this = this;
        try {
            if (data.status) {
                this.isHelpStep = 0;
                this.onCloseTabs();
            }
            else {
                if (data.code) {
                    if (data.code == ERROR_CODE.blocked || data.code == ERROR_CODE.authOver) {
                        this.popupComponent.showPopupErrorReturnEvent({ text: data.message, closePopupAfter: TIMERS_CONFIG.popupHideAfter }, function () {
                            _this.logout();
                        });
                    }
                    else {
                        this.popupComponent.showPopupError({ text: data.message });
                    }
                }
                else {
                    this.popupComponent.showPopupError({ text: data.message });
                }
            }
        }
        catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    };
    LoginComponent.prototype.isPhoneClassActive = function () {
        return this.phoneFormActive;
    };
    LoginComponent.prototype.isRegistrationClassActive = function () {
        return this.registrationPartActive;
    };
    LoginComponent.prototype.isPinClassActive = function () {
        return !this.phoneFormActive &&
            (!this.registrationPartActive || (this.registrationPartActive && (this.registrationPartStep === 2)));
    };
    LoginComponent.prototype.check = function (index, field, event) {
        if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
            event.preventDefault();
        }
        if (field.value && event.key !== 'Backspace') {
            if (index < this.inputs.toArray().length - 1) {
                this.inputs.toArray()[index + 1].nativeElement.focus();
            }
        }
        else if (event.key === 'Backspace') {
            if (index > 0) {
                field.setValue(null);
                this.inputs.toArray()[index - 1].nativeElement.focus();
            }
        }
    };
    LoginComponent.prototype.onRegisterNewUser = function () {
        var _this = this;
        var password = this.registrationForm.controls.password.value;
        var pin = this.pinForm.controls.digits.value;
        pin = pin.join('');
        var phone = this.phoneForm.controls.phone.value;
        var firstName = this.registrationForm.controls.firstName.value;
        var lastName = this.registrationForm.controls.lastName.value;
        var promo = this.registrationForm.controls.promo.value;
        if (!this.isRegistrationUpdate) {
            this.authenticationService.register(firstName, lastName, promo, password, phone, pin).subscribe(function (data) {
                _this.checkLoginSubmit(data);
            }, function (error) {
                _this.loaderService.hideAndShowTryAgain();
            }, function () {
                _this.loaderService.hide();
            });
        }
        else {
            this.authenticationService.addByPhone(phone, firstName, lastName, password, pin).subscribe(function (data) {
                _this.checkLoginSubmit(data);
            }, function (error) {
                _this.loaderService.hideAndShowTryAgain();
            }, function () {
                _this.loaderService.hide();
            });
        }
    };
    LoginComponent.prototype.focusPinInputs = function () {
        var _this = this;
        setTimeout(function () {
            _this.inputs.toArray()[0].nativeElement.focus();
        }, 0);
    };
    LoginComponent.prototype.focusPhoneInput = function () {
        setTimeout(function () {
            document.querySelector('input[formcontrolname=phone]').focus();
        });
    };
    LoginComponent.prototype.focusPasswordInput = function () {
        setTimeout(function () {
            document.querySelector('input[formcontrolname=password]').focus();
        });
    };
    LoginComponent.prototype.focusRegistrationPasswordInput = function () {
        setTimeout(function () {
            document.querySelector('.registration input[formcontrolname=password]').focus();
        });
    };
    LoginComponent.prototype.focusFirstNameInput = function () {
        setTimeout(function () {
            document.querySelector('input[formcontrolname=firstName]').focus();
        });
    };
    LoginComponent.prototype.goBackToLogin = function () {
        this.phoneFormActive = true;
        this.registrationPartActive = false;
        this.isRegistrationUpdate = false;
        this.userRegistrationUpdateData = null;
        this.authType = '';
        this.authCode = null;
        this.pinForm.reset();
        this.resetPinInput();
    };
    LoginComponent.prototype.resetPinInput = function () {
        this.pinForm.get('digits').clear();
        for (var i = 0; i < this.numOfDigits; i++) {
            this.pinForm.get('digits').push(this.formBuilder.control(null, Validators.required));
        }
    };
    LoginComponent.prototype.logout = function () {
        this.auth.logout();
        this.goBackToLogin();
        this.popupComponent.closePopup();
        if (this.phoneForm) {
            this.phoneForm.controls.phone.setValue(null);
        }
        else {
            this.phoneFormInit();
        }
        this.resetPinInput();
    };
    LoginComponent.prototype.isLoginBtnDisabled = function () {
        return this.phoneForm.controls.phone.invalid;
    };
    LoginComponent.prototype.isPinLoginBtnDisabled = function () {
        if (this.isSecondStepAuthAuthPin() || this.isSecondStepAuthSMSPin() || (this.isHelpStep === 2)) {
            return this.pinForm.controls.digits.invalid;
        }
        else {
            return this.pinForm.controls.password.invalid;
        }
    };
    LoginComponent.prototype.isSecondStepAuthSMSPin = function () {
        return this.authType === AUTH_TYPE.sms;
    };
    LoginComponent.prototype.isSecondStepAuthSMSPinPassword = function () {
        return this.authType === AUTH_TYPE.smsPinPassword;
    };
    LoginComponent.prototype.isSecondStepAuthAuthPin = function () {
        return this.authType === AUTH_TYPE.authPin;
    };
    LoginComponent.prototype.isSecondStepAuthAuthPinPassword = function () {
        return this.authType === AUTH_TYPE.authPinPassword;
    };
    LoginComponent.prototype.isSecondStepPassword = function () {
        return this.authType === AUTH_TYPE.password;
    };
    LoginComponent.prototype.onForgotPassword = function () {
        var _this = this;
        var phone = this.phoneForm.controls.phone.value;
        this.authenticationService.forgotPassword(phone).subscribe(function (data) {
            try {
                if (data.status) {
                    _this.resetPinInput();
                    _this.showHelpSecondStep();
                    _this.focusPinInputs();
                }
                else {
                    _this.popupComponent.showPopupError({ text: data.message });
                }
            }
            catch (e) {
                _this.loaderService.hideAndShowTryAgain();
            }
        }, function (error) {
            _this.loaderService.hideAndShowTryAgain();
        }, function () {
            _this.loaderService.hide();
        });
    };
    LoginComponent.prototype.toggleInputType = function () {
        if (this.isSecondStepAuthAuthPin() || this.isSecondStepAuthAuthPinPassword()) {
            this.authType = this.isSecondStepAuthAuthPin() ? AUTH_TYPE.authPinPassword : AUTH_TYPE.authPin;
            this.authCode = this.isSecondStepAuthAuthPin() ? AUTH_CODES.showAuthPin : AUTH_CODES.showPassword;
        }
        else if (this.isSecondStepAuthSMSPin() || this.isSecondStepAuthSMSPinPassword()) {
            this.authType = this.isSecondStepAuthSMSPin() ? AUTH_TYPE.smsPinPassword : AUTH_TYPE.sms;
            this.authCode = this.isSecondStepAuthSMSPin() ? AUTH_CODES.showSMSPin : AUTH_CODES.showPassword;
        }
        // this.authType = this.isSecondStepAuthAuthPin() ? AUTH_TYPE.authPinPassword : this.isSecondStepAuthAuthPinPassword() ? AUTH_TYPE.authPin :
        //                 this.isSecondStepAuthSMSPin() ? AUTH_TYPE.smsPinPassword : AUTH_TYPE.sms;
        if (this.isSecondStepAuthAuthPinPassword() || this.isSecondStepAuthSMSPinPassword()) {
            this.focusPasswordInput();
        }
        else {
            this.focusPinInputs();
        }
    };
    LoginComponent.prototype.onCloseTabs = function () {
        var _this = this;
        this.authenticationService.resetLoginBtnText();
        if (this.isHelpStep === 1) {
            this.isHelpStep = 0;
        }
        else if (this.isHelpStep === 2) {
            this.isHelpStep = 1;
        }
        else if (this.isHelpStep === 3) {
            this.mainTabsService.resetActiveTab();
            setTimeout(function () {
                _this.mainTabsService.makeLoginTabActive();
            });
        }
        else {
            this.mainTabsService.resetActiveTab();
        }
    };
    LoginComponent.prototype.showHelp = function () {
        this.isHelpStep = 1;
        this.authenticationService.helpLoginBtnText();
    };
    LoginComponent.prototype.showHelpSecondStep = function () {
        this.isHelpStep = 2;
    };
    LoginComponent.prototype.onRegistrationNextBtnClick = function () {
        if (this.isHelpStep === 3) {
            this.onSubmit();
            return;
        }
        if (this.registrationPartStep !== 3) {
            this.registrationPartStep += 1;
            switch (this.registrationPartStep) {
                case 2:
                    this.focusPinInputs();
                    break;
                case 3:
                    this.focusFirstNameInput();
                    break;
            }
        }
        else {
            this.onRegisterNewUser();
        }
    };
    LoginComponent.prototype.onRegistrationBackBtnClick = function () {
        if (this.isHelpStep === 3) {
            this.isHelpStep = 2;
            return;
        }
        if (this.registrationPartStep !== 1) {
            this.registrationPartStep -= 1;
        }
    };
    LoginComponent.prototype.isRegistrationNextBtnDisabled = function () {
        return (((this.registrationPartStep === 1) || (this.isHelpStep === 3)) && (!this.registrationForm.controls.password.value || (this.registrationForm.controls.password.value !== this.registrationForm.controls.reEnteredPassword.value))) ||
            ((this.registrationPartStep === 2) && this.pinForm.controls.digits.invalid) ||
            ((this.registrationPartStep === 3) && (!this.registrationForm.controls.firstName.value || !this.registrationForm.controls.lastName.value || (!this.isRegistrationUpdate && !this.registrationForm.controls.promo.value)));
    };
    LoginComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginComponent_Factory() { return new LoginComponent(i0.ɵɵinject(i1.FormBuilder), i0.ɵɵinject(i2.AppVersionService), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.LoaderService), i0.ɵɵinject(i5.PhoneMaskService), i0.ɵɵinject(i6.Router), i0.ɵɵinject(i7.MainTabsService), i0.ɵɵinject(i6.ActivatedRoute), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i8.AppPromptService), i0.ɵɵinject(i9.PopupComponent)); }, token: LoginComponent, providedIn: "root" });
    return LoginComponent;
}());
export { LoginComponent };
